// eu国家集合
export const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
// na国家集合
export const NA_SITES = ['us', 'ca'];
// 角标 save 金额国家集合
export const SAVE_SITES = ['us', 'ca', 'za'];

// 全站通用型Source
export const currentEmailSource = 'Y24_ECO_CREDITS_DAY';

// 结束通用型Source
export const finishedSource = 'Y24_ECO_CREDITS_DAY_FINISHED';

// za新品订阅
export const zaNewProductSource = 'Y24_ECO_CREDITS_DAY_NEW_PRODUCT';

// eu的各种Source
export const euEmailSource = {
    teaser: 'Y24_ECO_CREDITS_DAY_WARM_UP',
    return: 'Y24_ECO_CREDITS_DAY_ENCORE',
    allStages: 'Y24_ECO_CREDITS_DAY_ALL_STAGES',
    flashSale: 'Y24_ECO_CREDITS_DAY_SEC_KILL',
    tradeIn: 'Y24_ECO_CREDITS_DAY_TRADE_IN',
};

// 订阅参数设置
export const euSubscribeParams: Record<string, any> = {
    uk: {
        contactListId: '533441203',
        fields: [
            {
                id: '4430',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '31',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '7596',
                overwrite: false,
                type: 'multiple',
                value: [12],
            },
            {
                id: '9793',
                overwrite: false,
                type: 'multiple',
                value: [],
            },
        ],
    },
    eu: {
        contactListId: '478677407',
        fields: [
            {
                id: '4427',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '31',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '7596',
                overwrite: false,
                type: 'multiple',
                value: [12],
            },
            {
                id: '9793',
                overwrite: false,
                type: 'multiple',
                value: [],
            },
        ],
    },
    de: {
        contactListId: '1564288250',
        fields: [
            {
                id: '4425',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '31',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '7596',
                overwrite: false,
                type: 'multiple',
                value: [12],
            },
            {
                id: '9793',
                overwrite: false,
                type: 'multiple',
                value: [],
            },
        ],
    },
    fr: {
        contactListId: '1576151088',
        fields: [
            {
                id: '4428',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '31',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '7596',
                overwrite: false,
                type: 'multiple',
                value: [12],
            },
            {
                id: '9793',
                overwrite: false,
                type: 'multiple',
                value: [],
            },
        ],
    },
    it: {
        contactListId: '831339522',
        fields: [
            {
                id: '4429',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '31',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '7596',
                overwrite: false,
                type: 'multiple',
                value: [12],
            },
            {
                id: '9793',
                overwrite: false,
                type: 'multiple',
                value: [],
            },
        ],
    },
    es: {
        contactListId: '867167287',
        fields: [
            {
                id: '4426',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '31',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '7596',
                overwrite: false,
                type: 'multiple',
                value: [12],
            },
            {
                id: '9793',
                overwrite: false,
                type: 'multiple',
                value: [],
            },
        ],
    },
};
